import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FilterService } from '../../services/filter.service';
import { LearnerService } from '../../services/learner.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-learners-list-modal',
  templateUrl: './learners-list-modal.component.html',
  styleUrls: ['./learners-list-modal.component.scss']
})
export class LearnersListModalComponent implements OnInit {
  learnersList = []
  learnersListCopy = []
  searchText
  selectedLearner = []
  jobId
  afterFilter: string;
  loading = false
  constructor(public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _filter: FilterService,
    public learnerService: LearnerService,
    public _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    console.log("============finally=====", this.data);
    this.learnersList = this.data.learnerList
    this.learnersListCopy = this.data.learnerList
    this.jobId = this.data.jobId
  }



  // Change Events


  filter(searchText) {
    this.afterFilter = null
    if (searchText === '') {
      this.learnersList = this.learnersListCopy;
      // this.learnersList = this.copyInstructors
    }
    else {
      let tempInst = this._filter.filter(searchText, this.learnersListCopy, ['name']);
      this.learnersList = tempInst

      // let tempClient = this._filter.filter(searchText, this.copyClients, ['name'])
      // this.clients = tempClient

      if (tempInst.length <= 0) {
        this.afterFilter = "No user with matched search text found"
      }
    }

  }


  checkSelection(event) {
    console.log('Check Selection:', event);
    if (event.checked == true) {
      this.learnersList.forEach(instructor => {
        instructor.checked = true;
        let index = _.findIndex(this.selectedLearner, function (o) { return o._id == instructor._id })
        if (index == -1) {
          this.selectedLearner.push(instructor);
        }
      })
    }
    else {

      console.log('alreadySharedInstructor==>', this.selectedLearner);
      this.learnersList.forEach(instructor => {

        this.selectedLearner = [];

        let index = _.findIndex(this.selectedLearner, function (o) { return o._id._id == instructor._id })

        if (index == -1) {
          instructor.checked = false;
        }

      })
    }
  }

  onInstructorChange(event) {
    console.log(event);
    if (event.checked == true) {
      this.selectedLearner.push(event.source.value)
    }
    else if (event.checked == false) {
      this.selectedLearner.forEach((learner) => {
        if (learner._id == event.source.value._id) {
          this.selectedLearner.splice(learner, 1)
        }
      })
    }
    console.log("this.selectedLearner", this.selectedLearner);
  }


  // API Call

  share() {
    console.log("final learners list to emit", this.selectedLearner);
    console.log("job id details=====", this.jobId);

    this.loading = true
    let obj = {
      list: this.selectedLearner,
      jobId: this.jobId
    }
    this.learnerService.multipleLearnersInJob(obj).subscribe((res: any) => {
      console.log("when multiple learner is added", res);
      this.dialogRef.close(res)
      this.loading = false
    }, error => {
      console.log("error while add learaners", error);
      this.loading = false
      this.openSnackBar("Something went wrong.", "Ok");
    })
    // this.dialogRef.close(this.selectedLearner)
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 4000,
    });
  }

}
